import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { buildApiRoute } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class InquiryContactForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      contact: this.props.contact || {},
      emailValidationError: "",
      phoneValidationError: "",
      processing: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  finish() {
    this.validator.showMessages()
    if (
      this.validator.allValid() &&
      !this.state.emailValidationError &&
      !this.state.phoneValidationError
    ) {
      this.props.handleContact(this.state.contact)
    }
  }

  validateEmailAndPhone() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.checkEmail()
    }
  }

  checkEmail() {
    if (!this.state.contact.id) {
      this.setState({ processing: true })
      $.post(
        buildApiRoute("validate/email"),
        { email: this.state.contact.email },
        (data) => {
          this.setState({ emailValidationError: "" })
          this.checkPhone()
        }
      ).fail((data) => {
        this.setState({
          emailValidationError: data.responseJSON.error,
          processing: false,
        })
      })
    } else {
      this.checkPhone()
    }
  }

  checkPhone() {
    this.setState({ processing: true })
    $.post(
      buildApiRoute("validate/phone"),
      { phone: this.state.contact.phone },
      (data) => {
        this.setState({ phoneValidationError: "" })
        this.finish()
      }
    ).fail((data) => {
      this.setState({
        phoneValidationError: data.responseJSON.error,
        processing: false,
      })
    })
  }

  renderNameForm() {
    return (
      <FormGroup
        autoFocus
        name="contact.name"
        label="Full Name"
        value={this.state.contact.name || ""}
        onChange={this.handleInputChange}
        validation={this.validator.message(
          "full_name",
          this.state.contact.name,
          "required"
        )}
      />
    )
  }

  renderPhoneForm() {
    return (
      <div>
        <FormGroup
          name="contact.phone"
          label="Phone Number"
          value={this.state.contact.phone || ""}
          onChange={this.handleInputChange}
          validation={this.validator.message(
            "phone",
            this.state.contact.phone,
            "required|phone"
          )}
        />
        {this.validator.messageWhenPresent(this.state.phoneValidationError, {
          className: "bs-mb-3 text-danger text-bold",
        })}
      </div>
    )
  }

  renderForm() {
    if (!this.state.contact.id) {
      return (
        <div>
          {this.renderNameForm()}
          <FormGroup
            name="contact.email"
            label="Email"
            value={this.state.contact && this.state.contact.email}
            onChange={this.handleInputChange}
            validation={this.validator.message(
              "email",
              this.state.contact.email,
              "required|email"
            )}
          />
          {this.validator.messageWhenPresent(this.state.emailValidationError, {
            className: "bs-mb-3 text-danger text-bold",
          })}
          {this.renderPhoneForm()}
        </div>
      )
    } else if (!this.props.contact.phone && !this.props.contact.name) {
      return (
        <div>
          {this.renderNameForm()}
          {this.renderPhoneForm()}
        </div>
      )
    } else if (!this.props.contact.phone) {
      return this.renderPhoneForm()
    } else if (!this.props.contact.name) {
      return this.renderNameForm()
    }
  }

  render() {
    return (
      <div>
        <h3 className="text-lg">Contact Info</h3>
        {this.renderForm()}
        <NextButton
          click={this.validateEmailAndPhone.bind(this)}
          processing={this.state.processing}
          processingText=" Loading..."
          icon=""
          text="Continue"
          btnClass="btn btn-primary w-full"
        />
      </div>
    )
  }
}

InquiryContactForm.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  handleContact: PropTypes.func.isRequired,
}

export default InquiryContactForm
